import { render } from "./EditableReadingList.vue?vue&type=template&id=d3c60db6"
import script from "./EditableReadingList.vue?vue&type=script&lang=js"
export * from "./EditableReadingList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__